import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: [],
  standalone: false
})
export class FooterComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit(): void { }

  goBandi() {
    window.location.replace('cerca-bando')
  }

  goTo(route: string) {
    window.location.replace(route)
  }

}


